import { WidgetType } from '../..'
import { DOMUtils } from '../../../../utils/dom'
import { AbstractWidgetAdapter, IWidgetAdapter } from '../../../widgets/adapters/adapter'

export class OwnLocal extends AbstractWidgetAdapter implements IWidgetAdapter {
    public static DOM = {
        attrs: {
            adSize: 'data-ad-size',
            partnerId: 'data-uuid'
        }
    }

    public constructor(public el: Element, public adLight = false) {
        super(el, adLight)
    }

    /**
     * Load 3rd party javascript with widget data
     */
    public loadData(): void {
        const adSize = this.el.getAttribute(OwnLocal.DOM.attrs.adSize)
        const partnerId = this.el.getAttribute(OwnLocal.DOM.attrs.partnerId)
        const scriptSource = 'https://widget.secure.ownlocal.com/embed.js?uuid='
                                 + partnerId + '?h='
                                 + adSize
                                 + '&min_featured_level=0&category=all&subcategory=all&days_ago=30'

        // create element with id
        this.el.id = 'ownlocal'

        // only load the script if there is a partner ID to load
        if (partnerId) {
            const attributes = [{
                key: 'id',
                value: 'ownlocal-script'
            }, {
                key: 'data-active',
                value: 'businesses'
            }]

            DOMUtils.loadScript(scriptSource, attributes)
        }
    }

    /**
     * Remove local ads container
     */
    public removeWidgetContainer(): void {
        DOMUtils.nodes(document.querySelectorAll(`.js-widget-${WidgetType.OWNLOCAL}`))
        .forEach((el: Element) => el.remove())
    }
}
